'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _imaEvents = require('./imaEvents');

var _imaEvents2 = _interopRequireDefault(_imaEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImaApi = function (_EventEmitter) {
  _inherits(ImaApi, _EventEmitter);

  function ImaApi(google) {
    _classCallCheck(this, ImaApi);

    var _this = _possibleConstructorReturn(this, (ImaApi.__proto__ || Object.getPrototypeOf(ImaApi)).call(this));

    _this.google = google;
    return _this;
  }

  _createClass(ImaApi, [{
    key: 'getAdContainer',


    /**
     * Method responsible for loading a Google IMA AdDisplayContainer. The AdDisplayContainer
     * creates an IFRAME that loads the IMA Core SDK code which is required for the SDK to
     * operate properly.
     *
     * AdDisplayContainer:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdDisplayContainer
     *
     * @param containerElement {HTMLElement}: Container, usually DIV where video player will be housed
     * @param videoElement {HTMLVideoElement}: IMA Player video element
     * @returns {AdDisplayContainer}
     */
    value: function getAdContainer(containerElement, videoElement) {
      if (!containerElement || !videoElement) {
        throw new Error('Cannot get AdDisplayContainer without a containerElement and videoElement.');
      }
      return this._getAdDisplayContainer(containerElement, videoElement);
    }

    /**
     * Method responsible for loading a Google IMA AdsManager. The AdsManager provides an interface
     * that is used to manipulate the underlying media.
     *
     * AdsManager:
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsManager
     *
     * @param url {string}: The request url for the ad
     * @param adContainer {HTMLElement}: The element to display ads in
     * @param videoElement {HTMLVideoElement}: Video element to use for ad playback
     * @returns {Promise<void>}
     */

  }, {
    key: 'getAdsManager',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, adContainer, videoElement) {
        var managerLoadedEvent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!url || !adContainer || !videoElement)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Cannot get AdsManager without a url, adContainer or videoElement.');

              case 2:
                _context.next = 4;
                return this._getAdsManager(url, adContainer);

              case 4:
                managerLoadedEvent = _context.sent;
                return _context.abrupt('return', managerLoadedEvent.getAdsManager(videoElement));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAdsManager(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return getAdsManager;
    }()

    /**
     * Method to manage the request lifecycle of an ad via the Google IMA AdsLoader
     * and AdsRequest SDK modules. This method both wraps the request promise in
     * a timeout to abort the request if it takes too long, as well as publish an
     * AD_REQUESTED event so that listeners can use it.
     *
     * AdsLoader
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsLoader
     *
     * AdsRequest
     *  https://developers.google.com/interactive-media-ads/docs/sdks/html5/v3/apis#ima.AdsRequest
     *
     * @param adTagUrl
     * @param adContainer
     * @returns {Promise<any>}
     */

  }, {
    key: '_getAdsManager',
    value: function _getAdsManager(adTagUrl, adContainer) {
      var requestPromise = this._requestAd(adTagUrl, adContainer);
      this.emit(_imaEvents2.default.AdEvent.AD_REQUESTED);
      var timeoutPromise = ImaApi.promisfiedAdRequestTimeout();
      return Promise.race([requestPromise, timeoutPromise]);
    }
  }, {
    key: '_getAdDisplayContainer',
    value: function _getAdDisplayContainer(containerElement, videoElement) {
      var adContainer = new this.google.ima.AdDisplayContainer(containerElement, videoElement);
      adContainer.initialize();
      return adContainer;
    }
  }, {
    key: '_requestAd',
    value: function _requestAd(url, adContainer) {
      var adsLoader = new this.google.ima.AdsLoader(adContainer);
      var managerRequestPromise = this._promisfyAdManagerLoad(adsLoader);
      var adsRequest = new this.google.ima.AdsRequest();
      adsRequest.adTagUrl = url;
      adsLoader.requestAds(adsRequest);
      return managerRequestPromise;
    }
  }, {
    key: '_promisfyAdManagerLoad',
    value: function _promisfyAdManagerLoad(adsLoader) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        adsLoader.addEventListener(_this2.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, resolve, false);
        adsLoader.addEventListener(_this2.google.ima.AdErrorEvent.Type.AD_ERROR, reject, false);
      });
    }
  }], [{
    key: 'promisfiedAdRequestTimeout',
    value: function promisfiedAdRequestTimeout() {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          return reject(new Error('AdManager took to long to load.'));
        }, 5000);
      });
    }
  }]);

  return ImaApi;
}(_events2.default);

exports.default = ImaApi;